import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { ApplicationRef, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, ElementRef, EmbeddedViewRef, EventEmitter, HostListener, Injector, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService, ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { TypeaheadOrder } from 'ngx-bootstrap/typeahead/ngx-bootstrap-typeahead';
import { Observable, Subject, Subscription } from 'rxjs';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { HealthCareOrganization } from 'src/app/services/HealthCareOrganization';
import { TourService } from 'src/app/services/TourService';
import { UserService } from 'src/app/services/UserService';
import { ApiService } from 'src/app/services/api.service';
import { CommonValues } from 'src/app/services/commonValues';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { jobModuleConfig } from 'src/app/services/jobModuleConfig';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { PricePlanService } from '../../Price-subscritions/priceplanService';
import { JobTemplateComponent } from '../../job-template/job-template.component';
import { JobModel } from './../../../services/jobModel';
import { SearchData } from './../../../services/searchData';
import { SocketService } from './../../../services/socket.service';
import { StreamService } from './../../../services/stream.service';
// import { ModelPriceComponent } from './../../Price-subscritions/model-price/model-price.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { JoyrideModule } from 'ngx-joyride';
import { TruncatePipe } from '../../../pipe/TruncatePipe.pipe';
import { CompactCountPipe } from '../../../pipe/compact-count.pipe';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { ConnectionTemplateComponent } from '../../../templates/connection-template/connection-template.component';
import { TimezoneDatePipe } from '../../../timezone-date.pipe';
import { JobSubmitSkillfilterComponent } from '../../../widget/job-submit-skillfilter/job-submit-skillfilter.component';
import { MessageWidgetComponent } from '../../../widget/message-widget/message-widget.component';
// import { CandidatesPageComponent } from '../../candidate-module/candidates-page/candidates-page.component'; // Removed to break circular dependency - will use dynamic import
import { FlagComponent } from '../../flag/flag.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';




declare var $: any;

@Component({
  selector: 'app-jobs',
  standalone: true,
  // Note: CandidatesPageComponent removed from imports to break circular dependency - using dynamic loading instead
  imports: [CommonModule, FormsModule, BsDropdownModule, FlagComponent,
JobSubmitSkillfilterComponent, MessageWidgetComponent, ConnectionTemplateComponent, CommonSkeletonComponent, JobTemplateComponent, InfiniteScrollModule, TruncatePipe, CompactCountPipe, TimezoneDatePipe, JoyrideModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.scss'],
})



export class JobsComponent extends FormValidation
  implements OnInit, OnDestroy, OnChanges {

  /** Report Job hidden app-wide until the reporting flow is built.
   *  See the note on JobCardComponent.reportEnabled; grep "reportEnabled". */
  reportEnabled = false;

  @Output() jobReload = new EventEmitter<any>();
  public FORMERROR = super.Form;
  profileDetailResponse: any;
  private wasInside = false;
  dataPasstoSkillwidgets: Array<any> = [];
  removeTagvalues: any;
  candidateFoundStatus: string = "Fetching candidates ...";
  candidateSearchAfterKey: any = null;
  candidateScrollStopFlag: boolean = false;
  candidateScrollLoading: boolean = false;
  currentStatusList : { itemId: any; value: any; }[] = []
  inviteStatusList : { itemId: any; value: any; }[] = [];
  filterloadSubcription: Subscription;
  @HostListener('click')
  clickInside() {
    this.wasInside = true;
  }
  @HostListener('document:click')
  clickout() {
    if (!this.wasInside) {
      this.searchData.setjobHighLight('null');
    }
    this.wasInside = false;
  }
  loadDate: any = [];
  flag: boolean = false;
  userType: any;
  applyingJob: boolean = false
  checkedList: any = []
  @Input() applyingCandidate: any;
  @Output() selectedJob: EventEmitter<any> = new EventEmitter()
  @Output() updateStatusAndFilters: EventEmitter<any> = new EventEmitter()
  @Output() recallfilterAPI: EventEmitter<any> = new EventEmitter()
  @Input() getJobsugg: any;
  @Input() showStatus: any;
  @Input() jobsFoundStatus: any;
  @Input() responseReceived: any;
  @Input() passValues: Array<JobModel> = [];
  @Input() Obj: JobModel;
  @Input() viewSize: any;
  @Input() loadAPIcall: Boolean=false;

  // Dynamic component loading to break circular dependency
  // Template reference to access after modal renders
  @ViewChild('candidateSupplyTemplate', { static: false }) candidateSupplyTemplate: TemplateRef<any>;
  private candidatesPageContainer: ViewContainerRef | null = null;
  private candidatesPageComponentRef: ComponentRef<any> | null = null;
  @Input() focus: string;
  @Input() updateJobModule: jobModuleConfig;
  @Input() CheckboxforBusinessJobs:Boolean=false;
  // Business page "Member View" (admin previewing as a member). Only the 'business-row'
  // view reads it: the poster's own controls are hidden, like every other admin control
  // on the business page. Every other page leaves it false.
  @Input() memberPreview: boolean = false;
  @Output() passValuesUpdate = new EventEmitter<any>();

  @Output() jobListing = new EventEmitter();

  downloadurl = AppSettings.photoUrl;
  bsModalRef: BsModalRef;
  connectionRequestRef: BsModalRef;
  candidateSupplyRef: BsModalRef;
  candidateId
  object: any;
  currentTimeDate: string | Date;
  unit = { duration: '30' };

  jobsInvitedToApplyFlag: boolean = false
  // updatedDate: any = new Date();
  rtrformModal: BsModalRef;
  rtrformgrp: UntypedFormGroup

  // @Input() type:any;
  // @Input() data: any;
  userId = localStorage.getItem('userId');

  // Tracks which job card's kebab (More) menu is open so only ONE is ever open
  // at a time. ngx-bootstrap's dropdownToggle stops propagation internally (and
  // the kebab also stops it to avoid card navigation), so a second card's toggle
  // click never reaches the first dropdown's outside-click handler and the
  // previous menu stayed open. Binding [isOpen] to a single id closes the others.
  openKebabId: any = null;
  onKebabToggle(open: boolean, items: any) {
    if (open) {
      this.openKebabId = items?.jobId;
      // Cross-close: stopPropagation() on the triggers means the outside-click
      // never reaches an open status-pill menu, so close it here explicitly.
      this.openStatusPillId = null;
      // Notify other components to close their dropdowns
      this.searchData.setDropdownState('kebab', true);
    } else if (this.openKebabId === items?.jobId) {
      // Guard against a stale close event: opening a different row's kebab
      // flips this row's [isOpen] binding to false too, which fires this same
      // handler with open=false for the OLD row after the new id is already
      // set. Without this check that stale event wiped out the new id.
      this.openKebabId = null;
      this.searchData.setDropdownState('kebab', false);
    }
    // Force change detection to ensure UI updates
    this.changeDet.detectChanges();
  }

  // Same single-open pattern for the STATUS pill dropdown (Active / On Hold /
  // Inactive). The pill wrapper's (click)="$event.stopPropagation()" keeps the
  // click from selecting the card, but it also stops the outside-click that
  // would close another card's open status menu — so two menus could be open
  // at once. Mirrors candidates-page.component.ts `openStatusId`.
  openStatusPillId: any = null;
  onStatusPillToggle(open: boolean, items: any) {
    if (open) {
      this.openStatusPillId = items?.jobId;
      // Cross-close the kebab menu (see onKebabToggle).
      this.openKebabId = null;
      // Notify other components to close their dropdowns
      this.searchData.setDropdownState('status', true);
    } else if (this.openStatusPillId === items?.jobId) {
      // Same stale-close guard as onKebabToggle above.
      this.openStatusPillId = null;
      this.searchData.setDropdownState('status', false);
    }
    // Force change detection to ensure UI updates
    this.changeDet.detectChanges();
  }

  // Processing flag to prevent double-clicks on status change
  isProcessingStatusChange: boolean = false;

  clickItemActive: any;
  jobId
  seletedChatItem;
  followerFlag: boolean = false
  GigsumoConstant = GigsumoConstants;
  messageData: any;
  messagemodelflag: any;
  @ViewChild('childModal') childModal?: ModalDirective;
  @Output() suggcandidate: EventEmitter<any> = new EventEmitter();
  @ViewChild("myFileInputcandidate") myFileInputcandidate;
  @ViewChild('jobBodycardd', { static: false }) jobBodycardd: ElementRef;

  submited: boolean = false;
  networkflag: boolean = false
  showmodel = false
  creditform: UntypedFormGroup;
  connectionStatus: string;
  values: any;
  counterpartsDetails: any;
  clickEventsubscription: Subscription;
  loadscribtion: Subscription;
  streamRes: any = null;
  jobsResponse: any = [];
  updateJobListSubx: Subscription;
  queryParamsSubscription: Subscription;

  ngunsubscribe = new Subject();
  createSubjectSubscription: Subscription;
  dropdownCoordinatorSubscription: Subscription;
  itemsLoaded: boolean = false;
  constructor(private JobServicecolor: JobService, private userService: UserService, private activatedRoute: ActivatedRoute,
    private el: ElementRef, private _socket: SocketService, public gigsumoService: GigsumoService,
    private commonValues: CommonValues, private stremService: StreamService, private util: UtilService, private _location: Location,
    private formBuilder: UntypedFormBuilder, private searchData: SearchData, private a_route: ActivatedRoute,
    private modalService: BsModalService, private router: Router, private api: ApiService,    private tourService: TourService,
    private planService: PricePlanService, private changeDet: ChangeDetectorRef, private injector: Injector) {
    super();
    this.userType = localStorage.getItem('userType');
    this.searchData.getjobHighLight().subscribe(res => {
      if (res != 'jobId') {
        this.jobIdHighLight = res
      }
    });

    // Listen for dropdown state changes from detail header to close job card dropdowns
    this.dropdownCoordinatorSubscription = this.searchData.getDropdownState().subscribe(state => {
      if (state.open && state.type === 'detail-header') {
        this.openKebabId = null;
        this.openStatusPillId = null;
        this.changeDet.detectChanges();
      }
    });

    this.activatedRoute.params.subscribe(response => {
      if (response.networkflag) {
        this.networkflag = true;
      }
      if (response['candidatefilter'] == "true") {
        this.jobsInvitedToApplyFlag = true
      } else {
        this.jobsInvitedToApplyFlag = false
      }
    })

    this.clickEventsubscription = this.stremService.getstreamResponse().subscribe((res) => {
      this.streamRes = res;
    });

    this.createSubjectSubscription = this.searchData.getCreateSubjectJob().subscribe((res) => {
      if (res == true) {
        this.createANewSubject();
      }
    });

    // this.updateJobListSubx = this.commonValues.getJobData().subscribe(jobObject => {
    //   this.updateJobObject(jobObject);
    // })


    this.tourService.getTourSteps('JobPage').subscribe(data => {
      this.tourSteps = data;
    });

     this.filterloadSubcription = this.searchData.getfilterReload().subscribe(val => {
      if(val === 'reload'){
        this.jobReload.emit(val);
      }
     });

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.passValues != undefined && changes.passValues.currentValue != undefined) {
      this.passValues = changes.passValues.currentValue;
    }
    if (changes.Obj && changes.Obj.currentValue) {
      this.selectedItem = changes.Obj.currentValue.jobId;
    }
  }
  tourSteps: any[] = [];
  getTourData(stepId: string,key:string): string {
    const step = this.tourSteps.find(s => s.stepId === stepId);
    return step ? step[key] : 'Loading...';
  }


  BusinessJobChecked(checked, id,i){
    let index = this.passValues.findIndex(item => item.jobId === id.jobId);
    if(checked){
      this.passValues[index].transferJob=true;
      this.updateValues(checked);
    } else if(!checked){
      this.passValues[index].transferJob=false;
      this.updateValues(checked);
    }
  }

  imageErrors: { [key: string]: boolean } = {};
  onImageError(userId: string) {
    this.imageErrors[userId] = true;
  }

  updateValues(flag) {
    let data: any = {};
    data.flag = flag;
    data.response = this.passValues;
    this.passValuesUpdate.emit(data);
  }

  updateJobObject(JobObject): void {
    this.passValues.forEach((res, index) => {
      if (res.jobPostedBy == JobObject.jobPostedBy) {
        this.passValues[index] = { ...this.passValues[index], connectionStatus: JobObject.connectionStatus }
      }
      if (res.jobId == JobObject.jobId) {
        this.passValues[index] = { ...this.passValues[index], status: JobObject.status }

        JobObject.index = index
        this.jobReload.emit(JobObject);
      }
    });
  }
  isJobOwner(data: JobModel) {
    if(data) {
      return (
        ((data.status === "FILLED" || data.status === "CLOSED") && data.jobPostedBy === this.userId) ||
        (data.status != 'ACTIVE' && data.jobPostedBy != this.userId)
      )
    }
  }

  completeSubscription(): void {
    this.ngunsubscribe.complete()
  }

  nextSubscription(): void {
    this.ngunsubscribe.next(true)
  }

  createANewSubject(): void {
    this.ngunsubscribe = new Subject();
  }

  connect(values) {

    var data: any = {};
    data.userId = values.jobPostedBy;
    data.requestedBy = localStorage.getItem("userId");
    this.util.startLoader();
    this.api.create("user/connect", data).subscribe((res) => {
      // Stop for every response code — unhandled codes used to leave the loader spinning.
      this.util.stopLoader();
      if (res.code == "00000") {
        this.util.stopLoader();
        // this.connectionStatus = 'REQUEST_SENT';
        if(values) {
          values = {...values, connectionStatus: 'REQUEST_SENT'}
          // values.connectionStatus = this.connectionStatus;
          this.commonValues.setJobData(values); //This updates connection status in connectionTemplate and new-job components
        }
        //message to show connect request is sent successfully
        setTimeout(function () {
          Swal.fire({
            icon: "success",
            title: "Request sent successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }, 200);

      } else if (res.code == "88888") {
        this.util.stopLoader();
        Swal.fire({
          icon: "info",
          title: "Request failed",
          text: "Request coundn't be sent now. Please try after some time.",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (res.code == 'U0031') {
        this.util.stopLoader()
      }
    }, err => {
      this.util.stopLoader();

    });
  }
  BackBreadCream() {
    this._location.back();
  }
  LandingPage() {
    this.router.navigate(["landingPage"]);
  }


  // img: any;
  ngOnInit(): void {
    if(this.userType!="JOB_SEEKER"){
      this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
    }
    if(this.viewSize === "extra-small"){
      this.getAppliedFilter();
    }

    this.a_route.queryParams.subscribe((res) => {
      this.candidateId = res.candidateId
      this.jobId = res.jobId
    })


  }


  getAppliedFilter() {
    this.api.create('listvalue/findbyList' , {domain : "JOB_APPLICATION_BUYER_ACTIONS,JOB_INVITATION_SUPPLIER_ACTIONS"}).subscribe(res=>{
      const Csorted : Array<any> =  res.data.JOB_APPLICATION_BUYER_ACTIONS && res.data.JOB_APPLICATION_BUYER_ACTIONS.listItems;
      const Isorted : Array<any> =  res.data.JOB_INVITATION_SUPPLIER_ACTIONS && res.data.JOB_INVITATION_SUPPLIER_ACTIONS.listItems;
      if(Csorted && Isorted){
        this.currentStatusList = Csorted.map(x => {
          return {itemId : x.itemId , value : x.value};
        });
        this.inviteStatusList = Isorted.map(x => {
          return {itemId : x.itemId , value : x.value};
        });

      }
     });
  }




  getFilterValue(data: any) {

    let arrs: Array<any> = [];
    let find : any = {};

    if(data.currentStatus && data.currentStatus !=null){
      arrs = this.currentStatusList ? [...this.currentStatusList] : [];
      find = arrs.find(c => c.itemId === data.currentStatus);
    }
    else {
      arrs = this.inviteStatusList ? [...this.inviteStatusList] : [];
      find = arrs.find(c => c.itemId === data.inviteStatus);
    }

    if (find) return find.value;
    // Statuses missing from the master lists (e.g. L1/L2/L3 INTERVIEW) used
    // to render a blank pill — fall back to the normalized raw status
    // ('L1-INTERVIEW' → 'L1 Interview'), mirroring candidates-page.
    const raw = data.currentStatus || data.inviteStatus;
    return raw ? this.formatStatusLabel(raw) : null;
  }





  // Dynamic component loading method to break circular dependency
  private async loadCandidatesPageComponent(retryCount: number = 0) {
    const maxRetries = 5;

    // If container hasn't been found yet, try to get it from the modal's DOM
    if (!this.candidatesPageContainer) {
      if (retryCount < maxRetries) {
        // Try to find the container element in the modal's DOM
        const containerElement = document.getElementById('candidatesPageDynamicContainer');

        if (containerElement) {
          console.log('[Jobs] Found container element in modal DOM, getting ViewContainerRef...');

          // Get the ViewContainerRef for this element using the injector
          // We need to create a ViewContainerRef programmatically
          try {
            // Since we have the element, we can create components and append them to it
            // We'll store the element reference and create components directly
            this.candidatesPageContainer = this.injector.get(ViewContainerRef);

            // Actually, we need to get it from the element's injector if it exists
            // For now, let's proceed with creating the component and appending it to the element
            console.log('[Jobs] Using container element for dynamic component creation...');
          } catch (error) {
            console.log('[Jobs] Could not get ViewContainerRef from injector, will use ApplicationRef approach');
          }
        }

        // If still no container, retry with exponential backoff
        if (!this.candidatesPageContainer && !containerElement) {
          const delay = 50 * Math.pow(2, retryCount); // 50ms, 100ms, 200ms, 400ms, 800ms
          console.log(`[Jobs] CandidatesPageContainer not ready, retrying in ${delay}ms (attempt ${retryCount + 1}/${maxRetries})`);
          setTimeout(() => this.loadCandidatesPageComponent(retryCount + 1), delay);
          return;
        }
      } else {
        console.error('[Jobs] CandidatesPageContainer not available after maximum retries');
        return;
      }
    }

    console.log('[Jobs] Proceeding with dynamic component load...');

    // Load candidates page component when we have data to show
    if (this.applyResponse && this.applyResponse.length >= 0) {
      try {
        console.log('[Jobs] Loading CandidatesPageComponent dynamically...');

        // Dynamic import to break circular dependency
        const { CandidatesPageComponent } = await import('../../candidate-module/candidates-page/candidates-page.component');

        // Get the container element
        const containerElement = document.getElementById('candidatesPageDynamicContainer');

        if (containerElement) {
          // Clear previous content
          containerElement.innerHTML = '';

          // Use ApplicationRef to create and attach the component
          const componentFactory = this.injector.get(ComponentFactoryResolver);
          const factory = componentFactory.resolveComponentFactory(CandidatesPageComponent);

          // Create the component
          this.candidatesPageComponentRef = factory.create(this.injector);

          // Set inputs
          this.candidatesPageComponentRef.instance.viewSize = 'extra-small';
          this.candidatesPageComponentRef.instance.passValues = this.applyResponse;
          this.candidatesPageComponentRef.instance.jobData = this.jobData;
          this.candidatesPageComponentRef.instance.fromApply = true;
          this.candidatesPageComponentRef.instance.candidatesFoundStatus = this.candidateFoundStatus;
          this.candidatesPageComponentRef.instance.removeTag = this.removeTagvalues;

          // Subscribe to outputs
          this.candidatesPageComponentRef.instance.selectedCandidate.subscribe((data: any) => {
            this.getchildData(data);
          });

          // Attach the component's host view to the application
          const appRef = this.injector.get(ApplicationRef);
          appRef.attachView(this.candidatesPageComponentRef.hostView);

          // Append the component's DOM element to our container
          const domElem = (this.candidatesPageComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
          containerElement.appendChild(domElem);

          // Trigger change detection
          this.candidatesPageComponentRef.changeDetectorRef.detectChanges();

          console.log('[Jobs] CandidatesPageComponent loaded successfully with', this.applyResponse.length, 'candidates');
        } else {
          console.error('[Jobs] Container element not found in DOM');
        }
      } catch (error) {
        console.error('[Jobs] Error loading CandidatesPageComponent:', error);
      }
    } else {
      console.warn('[Jobs] No candidate data to display');
    }
  }

  ngOnDestroy(): void {
    this.ngunsubscribe.next(true);
    this.ngunsubscribe.complete();
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();

    }
    if (this.updateJobListSubx) {
      this.updateJobListSubx.unsubscribe();
    }

    if (this.loadscribtion) {
      this.loadscribtion.unsubscribe();
    }

    if (this.clickEventsubscription) {
      this.clickEventsubscription.unsubscribe();
    }
    if (this.filterloadSubcription) {
      this.filterloadSubcription.unsubscribe();
    }
    if (this.dropdownCoordinatorSubscription) {
      this.dropdownCoordinatorSubscription.unsubscribe();
    }
    // Clean up dynamically loaded component
    if (this.candidatesPageComponentRef) {
      // Detach from ApplicationRef if it was attached
      const appRef = this.injector.get(ApplicationRef);
      appRef.detachView(this.candidatesPageComponentRef.hostView);
      this.candidatesPageComponentRef.destroy();
      this.candidatesPageComponentRef = null;
    }
  }

  getStatusClass(items: any): any {
    if (!items || !items.status) return {};

    return {
      'active-label': items.status === 'ACTIVE' && items.jobPostedBy === this.userId,
      'active-label non-owner': items.status === 'ACTIVE' && items.jobPostedBy !== this.userId,
      'inactive-label': items.status === 'INACTIVE',
      'onhold-label': items.status === 'ON HOLD',
      'closed-label': items.status === 'CLOSED',
      'filled-label': items.status === 'FILLED',
      'blocked-label': items.status === 'BLOCKED',
      'draft-label': items.status === 'AWAITING HOST',
      'low-credit-label': items.status === 'INACTIVE_DUE_TO_LOW_CREDITS',
      'disabled': items.status === 'BLOCKED'
    };
  }

  async selectCheckbox(jobId: string, selected) {
    this.getCheckedItemList();

    let foundItems: Array<any> = this.passValues.filter(item => item.isSelected === true);
    let data = [];
    if (foundItems.length > this.planService.ACTIVE_INTERACTION) {
      this.passValues.map(ele => {
        if (ele.jobId === jobId) {
          ele.isSelected = false;
          selected.checked = false;
        }
        if (ele.isSelected) {
          data.push(ele);
        }
      });
      this.selectedJob.emit(JSON.stringify(data));
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let {membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
        if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
          availablePoints = ele.available
          actualPoints = ele.actual
          utilizedPoints = ele.utilized
          promotional = ele.promotional
        }
      })
      let popupType: "PAY" | "LIMIT"   | "UPGRADE" = "PAY";

      if (['Starter','Growth','ScaleX'].includes(membershipType)) {
        popupType = "LIMIT";
      }
      this.planService.expiredPopup("ACTIVE_INTERACTIONS",popupType , null, null, null,null, availablePoints, actualPoints, utilizedPoints, promotional);


    }

  }
  getInitials(fullname: string): string {
    return this.JobServicecolor.getInitials(fullname);
  }

  getColor(fullname: string): string {
    return this.JobServicecolor.getColor(fullname);
  }
  getFullNameTextColor(fullname: string): string {
    return this.JobServicecolor.getFullnameTextColor(fullname);
  }
  widgetReload(data) {
    //this.clickItemActive=data;
    this.suggcandidate.emit(data);

  }


  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.passValues.length; i++) {
      if (this.passValues[i].isSelected)
        this.checkedList.push(this.passValues[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
    this.selectedJob.emit(this.checkedList);
  }

  c: any;
  d: any;
  fromBusinessPage: boolean = false
  fromBusinessPageId: any;
  submitRTR: boolean = false;
  formValidate(val) {
    this.submitRTR = true

    const expression: RegExp = /^-?(0|[1-9]\d*)?$/;

    const result: boolean = expression.test(val)
    if (result == true && this.rtrformgrp.valid && this.rtrformgrp.value.termsandcondition) {
      this.rtrformModal.hide()
      this.apply(this.tempApplyValue);
    }

  }

  checkConnectionStatus(values): Observable<any> {
    const apiURL = 'user/checkConnectionStatus';
    const params = new HttpParams()
      .set('userId', this.userId)
      .set('connnectorId', values.jobPostedBy);

    const urlWithParams = `${apiURL}?${params.toString()}`;
    return this.api.query(urlWithParams);
  }

  tempApplyValue: any
  jobData: any;
  apply(values: any, connectionTemplate?: TemplateRef<any>, candidateSupplyTemplate?: TemplateRef<any>) {
    this.jobData = {...values};
    let data = {...values}
    if (values.isFeatured) {
      this.proceedToApply(data, candidateSupplyTemplate);
    } else if (!data.isFeatured) {
      if (data.connectionStatus === 'CONNECTED') {
        this.proceedToApply(data, candidateSupplyTemplate);
      } else if (data.connectionStatus !== 'CONNECTED') {
        this.proceedToApply(data, candidateSupplyTemplate);
        // to be used later
        // this.openConnectionTemplate(values.connectionStatus, values, connectionTemplate);
      }
    }
  }

  closeCandidateSupplyModal() {
    this.modalService.hide(1);
    this.dataPasstoSkillwidgets = []
  }

  closeModal(event) {

    this.closeCandidateSupplyModal();
  }

  applyResponse: any = [];
  myCandidatesForApply(jobId: string, candidateSupplyTemplate: any) {
    const responseData: any = {
      "source": {
        "all": false,
        "myCandidates": true,
        "allPlatFormCandidates": false,
        "teamCandidates": false,
        "benchNetworkCandidates": false,
        "freeLancerNetworkCandidates": false,
        "mtaNetworkCandidates": false,
        "jobSeekerNetworkCandidates": false,
        "featured": false,
        "suggestedCandidates": false
      },
      "workType": {
        "all": false,
        "remoteWork": false,
        "relocationRequired": false,
        "workFromHome": false
      },
      "jobId": jobId,
      "workAuthorization": [],
      "engagementType": [],
      "availableIn": [],
      "status": [],
      "searchAfterKey": null,
      "city": null,
      "state": null,
      "country": null,
      "zipCode": null,
      "submissionFilters": [],
      "postedFrom": null,
      "postedTo": null,
      "limit": 10,
      "userId": this.userId,
      "searchContent": ""
    }

    // Reset scroll state for new modal open
    this.candidateSearchAfterKey = null;
    this.candidateScrollStopFlag = false;
    this.candidateScrollLoading = false;

    this.api.create('candidates/filter', responseData).subscribe(res => {
      if (res.code === GigsumoConstants.SUCESSCODE) {
        this.applyResponse = res.data.candidateList;
        if (this.applyResponse.length === 0) {
          this.candidateFoundStatus = "Couldn't find any Candidates for the applied filters.";
        }

        // Capture searchAfterKey for pagination
        const searchAfterKey = res.data.searchAfterKey;
        if (searchAfterKey && searchAfterKey.length > 0) {
          this.candidateSearchAfterKey = searchAfterKey;
        } else {
          this.candidateScrollStopFlag = true;
        }

        const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
        this.candidateSupplyRef = this.modalService.show(candidateSupplyTemplate, config);

        // Load component after modal is rendered with proper change detection
        setTimeout(() => {
          console.log('Modal shown, loading CandidatesPageComponent...');
          this.changeDet.detectChanges();
          this.loadCandidatesPageComponent();
        }, 150);
      }
    });

  }

  onCandidateSupplyScroll() {
    if (this.candidateScrollStopFlag || this.candidateScrollLoading || !this.candidateSearchAfterKey) {
      return;
    }

    this.candidateScrollLoading = true;
    const jobId = this.jobData?.jobId;

    const responseData: any = {
      "source": {
        "all": false,
        "myCandidates": true,
        "allPlatFormCandidates": false,
        "teamCandidates": false,
        "benchNetworkCandidates": false,
        "freeLancerNetworkCandidates": false,
        "mtaNetworkCandidates": false,
        "jobSeekerNetworkCandidates": false,
        "featured": false,
        "suggestedCandidates": false
      },
      "workType": {
        "all": false,
        "remoteWork": false,
        "relocationRequired": false,
        "workFromHome": false
      },
      "jobId": jobId,
      "workAuthorization": [],
      "engagementType": [],
      "availableIn": [],
      "status": [],
      "searchAfterKey": this.candidateSearchAfterKey,
      "city": null,
      "state": null,
      "country": null,
      "zipCode": null,
      "submissionFilters": [],
      "postedFrom": null,
      "postedTo": null,
      "limit": 10,
      "userId": this.userId,
      "searchContent": ""
    };

    this.api.create('candidates/filter', responseData).subscribe(res => {
      this.candidateScrollLoading = false;
      if (res.code === GigsumoConstants.SUCESSCODE) {
        const candidateList = res.data.candidateList;
        const searchAfterKey = res.data.searchAfterKey;

        if (!candidateList || candidateList.length === 0 ||
          JSON.stringify(this.candidateSearchAfterKey) === JSON.stringify(searchAfterKey)) {
          this.candidateScrollStopFlag = true;
          return;
        }

        // Append new candidates
        this.applyResponse = [...this.applyResponse, ...candidateList];

        // Update searchAfterKey for next page
        if (searchAfterKey && searchAfterKey.length > 0) {
          this.candidateSearchAfterKey = searchAfterKey;
        } else {
          this.candidateScrollStopFlag = true;
        }

        // Update the dynamically loaded component with new data
        if (this.candidatesPageComponentRef) {
          this.candidatesPageComponentRef.instance.passValues = this.applyResponse;
          this.candidatesPageComponentRef.instance.syncFormArrayWithPassValues();
          this.candidatesPageComponentRef.changeDetectorRef.detectChanges();
        }
      }
    }, () => {
      this.candidateScrollLoading = false;
    });
  }

  termsCheck: boolean;
  resumeData: any = [];
  rtrFormData: any;
  getchildData(data: any) {
    this.termsCheck = data.terms;
    if (data.resumes) {
      this.resumeData = data.resumes

    }
    if (data.value != null) {
      this.dataPasstoSkillwidgets = data.value;
      this.rtrFormData = data.formData;
    } else {
      this.dataPasstoSkillwidgets = [];
    }
  }

  removeUserfromTag(data) {


    if (data === "CLEAR") {
      this.dataPasstoSkillwidgets = [];
      return;
    }

    this.removeTagvalues = data;
    this.applyResponse = this.applyResponse.map(element => {
      if (element.candidateId === data.candidateId) {
        element.isSelected = false;
        element.remove = true;
      }
      return element;
    });

    this.dataPasstoSkillwidgets.forEach((element, i) => {
      if (element.candidateId === data.candidateId) {
        this.dataPasstoSkillwidgets.splice(i, 1);
        this.dataPasstoSkillwidgets = [...this.dataPasstoSkillwidgets];
        element.isSelected = false;
      }
    });

    // Update dynamically loaded component if it exists
    if (this.candidatesPageComponentRef) {
      this.candidatesPageComponentRef.instance.removeTag = this.removeTagvalues;
      this.candidatesPageComponentRef.instance.passValues = this.applyResponse;
      this.candidatesPageComponentRef.changeDetectorRef.detectChanges();
    }

  }

  refreshPage(): void {

    // window.location.reload();

  }

  cancelConnectionRequest() {
    this.modalService.hide(1);
  }

  async proceedToApply(values, candidateSupplyTemplate) {
    try {
      this.util.startLoader();
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { userDetail, isExpired, membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      if (userDetail && userDetail.userPlanAndBenefits && userDetail.userPlanAndBenefits.benefitsUsages) {
        userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available;
            actualPoints = ele.actual;
            utilizedPoints = ele.utilized;
            promotional = ele.promotional;
          }
        });
      } else {
        this.util.startLoader();
        this.applymodal(values, candidateSupplyTemplate);

        return;
      }

      if (isExpired) {
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter','Growth','ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }

        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null,null, availablePoints, actualPoints, utilizedPoints, promotional);

      } else {
        this.util.startLoader();
        this.applymodal(values, candidateSupplyTemplate);

      }
    } catch (error) {
    } finally {
      setTimeout(() => {
        this.util.stopLoader();
      },1500);
    }

  }
  applymodal(values, candidateSupplyTemplate){

    this.myCandidatesForApply(values.jobId, candidateSupplyTemplate);
    this.c = this.activatedRoute.pathFromRoot[0]['_routerState']['snapshot'].url
    this.d = this.c.substr(1, 8)
    if (this.d == 'business' && localStorage.getItem('isAFollower') == 'false') {
      // Swal.fire({
      //   icon: "info",
      //   title: "Following Required!",
      //   text: "Please, follow the business page for applying the job.",
      //   showConfirmButton: true,
      // });
    } else {
      if (this.d == 'business') {
        this.fromBusinessPage = true
        this.fromBusinessPageId = localStorage.getItem('businessId')

      } else {
        this.fromBusinessPage = false
      }
      values.clientType = values.user.clientType;
      values.userType = values.user.userType;
      let datas: any = {};
      var datacheck = [{ 'userId': localStorage.getItem('userId') }]
      datas.jobPostedBy = localStorage.getItem('userId');
      datas.jobId = values.jobId;
      datas.appliedBy = datacheck;
      values.jobfilter = true;
      values.filterTitle = 'Select';
      if (this.fromBusinessPage == true) {
        values.fromBusinessPage = true
        values.fromBusinessPageId = this.fromBusinessPageId
      } else {
        values.fromBusinessPage = false
      }
      values.jobDescription = "";


    }
  }

  get rtrFormControls() {
    return this.rtrformgrp.controls
  }

  like(values: any) {
   if (values.isProcessingLike) return;
   if(values.jobPostedBy!=localStorage.getItem('userId')){
    let datas: any = {};
    if (values.isLiked == false || values.isLiked == null) {
      datas.likeStatus = "LIKE"
    } else if (values.isLiked == true) {
      datas.likeStatus = "UNLIKE"
    }

    datas.userId = localStorage.getItem('userId');
    datas.jobId = values.jobId;
    values.isProcessingLike = true;
    this.util.startLoader();
    this.api.updatePut("jobs/updateJobLiked", datas).subscribe((res) => {
      this.passValues.forEach(ele => {
        if (res.data.jobData.jobId == ele.jobId) {
          ele.likesCount = res.data.jobData.likesCount;
          ele.isLiked = res.data.jobData.isLiked;
        }
      })

       values.isProcessingLike = false;
       this.util.stopLoader();
    }, err => {
      values.isProcessingLike = false;
      this.util.stopLoader();
    });
   }else{
    this.goTo(values, 'jobs-liked')
   }
  }

  goTo(values, param) {

    this.selectedItem = values.jobId;
    console.log('job.component.ts goTo called:', { param, values, userId: this.userId, jobPostedBy: values.jobPostedBy });

    if (this.updateJobModule) {

      if (values.jobPostedBy == this.userId) {

        if (param == 'jobs-applied' && values.appliedCount > 0 && values.status != 'ON HOLD') {
          this.updateJobModule.jobDetails.apply(this.updateJobModule.source, ["job-applicants", { value: values, for: "TAB_ROUTE" }]);
        } else if (param == 'views' && values.status != 'ON HOLD') {
          this.updateJobModule.jobDetails.apply(this.updateJobModule.source, ["jobs-viewed", { value: values, for: "TAB_ROUTE" }]);
        }
        else if (param == 'jobs-liked' && values.status != 'ON HOLD') {
          this.updateJobModule.jobDetails.apply(this.updateJobModule.source, ["jobs-liked", { value: values, for: "TAB_ROUTE" }]);
        }
        else if (param == 'candidates-invited' && values.status != 'ON HOLD' && values.interestShownCount > 0) {
          this.updateJobModule.jobDetails.apply(this.updateJobModule.source, ["candidates-invited", { value: values, for: "TAB_ROUTE" }]);
        }
      }
      else if (values.jobPostedBy != this.userId) {

        if (param == 'jobs-applied' && values.appliedCount > 0 && values.status != 'ON HOLD') {
          this.updateJobModule.jobDetails.apply(this.updateJobModule.source, ["job-applicants", { value: values, for: "TAB_ROUTE" }]);
        } else if (param == 'views' && values.status != 'ON HOLD') {
          this.updateJobModule.jobDetails.apply(this.updateJobModule.source, ["job-details", { value: values, for: "TAB_ROUTE" }]);
        }
        else if (param == 'candidates-invited' && values.status != 'ON HOLD' && values.interestShownCount > 0) {
          this.updateJobModule.jobDetails.apply(this.updateJobModule.source, ["candidates-invited", { value: values, for: "TAB_ROUTE" }]);
        }
        else if (values.appliedCount > 0 && param == 'candidate-applied' && values.status != 'ON HOLD' && values.candidatesApplied && this.userType!='RECRUITER') {
          this.updateJobModule.jobDetails.apply(this.updateJobModule.source, ["candidate-applied", { value: values, for: "TAB_ROUTE" }]);
        }
      }

    } else {
      // Fallback to router navigation when updateJobModule is not available (e.g., from business page)
      console.log('Using router navigation fallback');
      if (values.jobPostedBy == this.userId) {
        if (param == 'jobs-applied' && values.appliedCount > 0 && values.status != 'ON HOLD') {
          console.log('Navigating to job-applicants for job poster');
          this.router.navigate(['/newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-applicants' } });
        } else if (param == 'views' && values.status != 'ON HOLD') {
          console.log('Navigating to jobs-viewed for job poster');
          this.router.navigate(['/newjobs'], { queryParams: { jobId: values.jobId, tabName: 'jobs-viewed' } });
        } else if (param == 'jobs-liked' && values.status != 'ON HOLD') {
          console.log('Navigating to jobs-liked for job poster');
          this.router.navigate(['/newjobs'], { queryParams: { jobId: values.jobId, tabName: 'jobs-liked' } });
        } else if (param == 'candidates-invited' && values.status != 'ON HOLD' && values.interestShownCount > 0) {
          console.log('Navigating to candidates-invited for job poster');
          this.router.navigate(['/newjobs'], { queryParams: { jobId: values.jobId, tabName: 'candidates-invited' } });
        }
      }
      // For non-job-posters, no navigation - do nothing
    }

  }





  openConnectionTemplate(connectionStatus, values, connectionTempate?: TemplateRef<any>) {
    this.connectionStatus = connectionStatus;
    this.values = values;
    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'sm',
    };
    this.api.query("user/" + this.values.jobPostedBy).subscribe(res => {
      if (res.code == '00000') {
        this.counterpartsDetails = res;
        this.connectionRequestRef = this.modalService.show(connectionTempate, initialState);
      }
    })
  }

  showinviteResumeView(items): boolean {
    if (this.focus === 'candidate' && (items.inviteStatus == undefined && items.currentStatus == undefined)) {
      return true;
    } else if (this.focus === 'resume' && items.resumeRequestStatus != 'COMPLETED' && items.resumeRequestStatus != 'INITIATED') {
      return true;
    } else {
      return false;
    }
  }


  selectedItem: any;
  /** Club a job's primary + secondary skills into a single list for the card's
   *  skills chips (the "large" listing on /business/jobs showed primary only).
   *  Order: primary first, then secondary. Duplicates are kept (no dedup) so the
   *  count reflects every skill on the job. */
  getAllSkills(items: any): any[] {
    return [
      ...(items?.primarySkills || []),
      ...(items?.secondarySkills || []),
    ];
  }

  // ── viewSize 'business-row' (business Jobs page, wireframe rows).
  // Status pill colour, one class per status the 'large' label classes cover.
  bjrStatusClass(status: string): string {
    switch (status) {
      case 'ACTIVE': return 'bjr-pill--active';
      case 'ON HOLD': return 'bjr-pill--hold';
      case 'FILLED': return 'bjr-pill--filled';
      case 'INACTIVE': return 'bjr-pill--inactive';
      case 'DEACTIVATED': return 'bjr-pill--inactive';
      case 'AWAITING HOST': return 'bjr-pill--awaiting';
      case 'INACTIVE_DUE_TO_LOW_CREDITS': return 'bjr-pill--lowcredit';
      case 'DRAFTED': return 'bjr-pill--draft';
      case 'BLOCKED': return 'bjr-pill--blocked';
      default: return 'bjr-pill--inactive';
    }
  }

  async open(values: any, index?: any) {

    this.selectedItem = values.jobId;

    try {

      let data: any = {
        jobId: values.jobId,
        jobPostedBy: this.userId
      };

      if (values.jobPostedBy != this.userId && !values.isViewed) {
        this.api.updatePut("jobs/updateJobViewed", data).subscribe((res: any) => {
          if (res.code === GigsumoConstants.SUCESSCODE) {
            this.updateJobModule.jobDetails.apply(this.updateJobModule.source, [values, { value: null, for: "JOB_DETAIL" }]);
            values.isViewed = true;
          }
        });
      }
      else if (values.isViewed || values.jobPostedBy === this.userId) {
        this.updateJobModule.jobDetails.apply(this.updateJobModule.source, [values, { value: null, for: "JOB_DETAIL" }]);
      }
    } catch (error) {

    } finally {
      this.util.stopLoader();
    }
  }

  routeBusiness(data : JobModel){
    const {jobPostedBy , jobId} =data;

    if(jobPostedBy === this.userId){
      this.router.navigate(['newjobs'], { queryParams: { jobId : jobId , tabName : 'job-details' , From: "BUSINESS_JOBS" } });
    }
    else if(jobPostedBy != this.userId){
      this.router.navigate(['newjobs'], { queryParams: { jobId : jobId , tabName : 'job-details' , From: "BUSINESS_CONNECTION_JOBS" } });
    }

  }

  downgradeJob(items) {

    let data: any = {}
    data = items;
    data.isFeatured = false;
    //data.points = 0;
    data.consumptionType = null;
    data.jobReferenceId=data.jobId;
    this.api.updatePut("jobs/updateJob", data).subscribe((res) => {

      this.passValues.forEach(ele => {
        if (items.jobId == ele.jobId) {
          ele.updatedOn = res.data.jobData.updatedOn;

          // this.sortDate(this.passValues);
        }
      })
      if (this.streamRes != null && this.streamRes.code == '00000') {
        this.stremService.clear();
      }
      this.util.stopLoader();
      if (res.code == '00000') {

        Swal.fire({
          icon: "success",
          title: "Downgraded Successfully",
          showDenyButton: false,
          showConfirmButton: false,

          timer: 2000,

          // timer: 3500,
        })
        this.selectedJob.emit(null);
        this.jobReload.emit("reload")

      }
    }, err => {
      this.util.stopLoader();
    });
  }
  userData = {
    userId: localStorage.getItem('userId'),
    userType: localStorage.getItem('userType')
  }

  updatedDate: string;
  availablepoints: any;
  //upgrade job function by monisha
  async featurejobvalues(item) { 

    // if its free plan just open the credits modal
    if(this.MemberShipType === GigsumoConstants.FREE_PLAN){
      await this.creditsBasedUpgrade(item);
      return;
    }

    const isPlanValid = await this.planService.checkUserPlanValid("JOBS_CANDIDATE_SPOTLIGHTS" , "FEATURED");

    // if(item.featuredConsumptions && item.featuredConsumptions != null && item.featuredConsumptions.length > 0){
    //   const latestConsumption = item.featuredConsumptions.reduce((latest, current) => {
    //     return !latest || new Date(current.toDate) > new Date(latest.toDate) ? current : latest;
    //   }, null);
  
    //   if (latestConsumption) {
    //     console.log('Latest type:', latestConsumption.type);
    //   }

    // }


    if( isPlanValid && (item.isFeatured === undefined || !item.isFeatured)){
      // FIX: Check if CREDITS was used today BEFORE using SPOTLIGHT
      // Get user's timezone date for comparison
      const profileResponse = await this.userService.userProfileDetails(this.userData);
      let currenttimezonedate = new Date(profileResponse.currentTimeByTimezone);
      currenttimezonedate.setHours(0, 0, 0, 0);

      if (this.wasUpgradedViaCreditToday(item, currenttimezonedate)) {
        // CREDITS was used today → redirect to creditsBasedUpgrade()
        // This will show the popup: "You will not be charged for this job again..."
        // On OK click → this.upgradeJobs(item, 'CREDITS') → Uses CREDITS type
        await this.creditsBasedUpgrade(item);
      } else {
        // No CREDITS used today → proceed with SPOTLIGHT
        this.upgradeJobs(item);
      }
    }
    else{
      this.creditsBasedUpgrade(item);
    } 

  }

  /**
   * Checks if the job was upgraded via CREDITS today (not via SLOTS)
   * Used to determine if "already paid" message should be shown
   * Returns true if type=CREDITS regardless of credits value (even if 0)
   * This ensures re-upgrades after downgrade use CREDITS flow, not SPOTLIGHT
   */
  private wasUpgradedViaCreditToday(item: any, currentDate: Date): boolean {
    if (!item.featuredConsumptions || item.featuredConsumptions.length === 0) {
      return false;
    }

    // Find consumption entries for today
    const todayConsumptions = item.featuredConsumptions.filter(consumption => {
      const consumptionDate = new Date(consumption.fromDate);
      consumptionDate.setHours(0, 0, 0, 0);
      return consumptionDate.getTime() === currentDate.getTime();
    });

    // Check if any of today's consumptions used CREDITS type
    // Returns true if type=CREDITS regardless of credits value
    return todayConsumptions.some(consumption =>
      consumption.type?.toUpperCase() === 'CREDITS'
    );
  }

  async creditsBasedUpgrade(item){
    this.profileDetailResponse = await this.userService.userProfileDetails(this.userData);
    let currenttimezonedate = new Date(this.profileDetailResponse.currentTimeByTimezone);
    currenttimezonedate.setHours(0, 0, 0, 0);
    this.updatedDate = String(item.featuredUpdatedOn);
    let currentDates = this.util.dateFormatestring(this.updatedDate);
    this.availablepoints = this.profileDetailResponse.userCredits;
    let alertdate = new Date(this.profileDetailResponse.currentTimeByTimezone);

    if (item.isFeatured == undefined || currenttimezonedate > currentDates && item.isFeatured == false) {
      this.planService.expiredPopup("UPGRADE_JOBS", "UPGRADE", item, currenttimezonedate, currentDates,alertdate, this.availablepoints, null, null, null);

    } else if (item.isFeatured == false) {
      // Check if previously upgraded via CREDITS today
      if (this.wasUpgradedViaCreditToday(item, currenttimezonedate)) {
        // Previous upgrade was via CREDITS - show "already paid" message
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        });

        swalWithBootstrapButtons
          .fire({
            title: 'You will not be charged for this job again for the day as it has already been paid for.',
            icon: "warning",
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: 'Ok',
            cancelButtonText: 'No',
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.upgradeJobs(item, 'CREDITS');
            }
          });
      } else {
        // Previous upgrade was via SLOTS (or no credit purchase today)
        // Open credit-based upgrade modal
        this.planService.expiredPopup("UPGRADE_JOBS", "UPGRADE", item, currenttimezonedate, currentDates, alertdate, this.availablepoints, null, null, null);
      }
    }
  }

  async checkAlreadyPaid(item){
    if(item.featuredConsumptions != null){
      const now = new Date();
      const currentByCredits = item.featuredConsumptions.filter(fc => {
        const from = new Date(fc.fromDate);
        const to = new Date(fc.toDate);
  
        return fc.credits > 0 && from <= now && to >= now;
      });

      if(currentByCredits == true){
        this.creditsBasedUpgrade(item);
        return;
      }
    }

    this.upgradeJobs(item);
    

    // //Day end upgrade validation by monisha
    // if (alertdate.getHours() >= 18 && (currenttimezonedate > featureddate && item.isFeatured == false|| item.isFeatured == null || item.isFeatured == undefined)) {
    //   const swalWithBootstrapButtons = Swal.mixin({
    //     customClass: {
    //       confirmButton: 'btn btn-success',
    //       cancelButton: 'btn btn-danger',
    //     },
    //     buttonsStyling: false,
    //   });

    //   swalWithBootstrapButtons
    //     .fire({
    //       title: "The day is about to end.",
    //       text: "Are you sure you want to upgrade until EOD?",
    //       icon: "warning",
    //       showCancelButton: true,
    //       allowOutsideClick: false,
    //       allowEscapeKey: false,
    //       confirmButtonText: 'Yes',
    //       cancelButtonText: 'No',
    //       reverseButtons: true,
    //     })
    //     .then((result) => {
    //       if (result.isConfirmed) {
    //         this.upgradeJobs(item,'CREDITS');
    //       }
    //     });
    // } else {
    //   if (item.isFeatured === undefined ||(currenttimezonedate > featureddate && item.isFeatured === false)) {
    //     this.upgradeJobs(item);
    //   } else if (item.isFeatured === false) {
    //     const swalWithBootstrapButtons = Swal.mixin({
    //       customClass: {
    //         confirmButton: 'btn btn-success',
    //         cancelButton: 'btn btn-danger',
    //       },
    //       buttonsStyling: false,
    //     });
  
    //     swalWithBootstrapButtons
    //       .fire({
    //         title: 'You will not be charged for this job again for the day as it has already been paid for.',
    //         // text: this.dynamicMessage,
    //         icon: "warning",
    //         showCancelButton: true,
    //         allowOutsideClick: false,
    //         allowEscapeKey: false,
    //         confirmButtonText: 'Ok',
    //         cancelButtonText: 'No',
    //         reverseButtons: true,
    //       })
    //       .then((result) => {
    //         if (result.isConfirmed) {
    //           this.upgradeJobs(item,'CREDITS');
    //         } 
    //       });
    //   }
    // }
  }

  getActiveUrgencyDays(job: any): number | null {
    if (!job?.isFeatured) return null;

    const now = new Date();

    if (job?.featuredConsumptions?.length > 0) {
      const lastConsumption = job.featuredConsumptions[job.featuredConsumptions.length - 1];

      // Use toDate directly from backend (most accurate)
      if (lastConsumption.toDate) {
        const toDate = new Date(lastConsumption.toDate);
        const diffMs = toDate.getTime() - now.getTime();

        // If upgrade has expired, return null (don't show badge)
        if (diffMs <= 0) return null;

        // Convert to days, rounding up (any remaining time counts as 1 day)
        const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        return days > 0 ? days : 1;
      }

      // Fallback: use dayCount if toDate not available
      const dayCount = lastConsumption.dayCount || 1;
      return dayCount;
    } else if (job?.featuredUpdatedOn) {
      const featuredDate = new Date(job.featuredUpdatedOn);
      const urgencyEndDate = new Date(featuredDate.getTime() + (2 * 24 * 60 * 60 * 1000));
      const diffMs = urgencyEndDate.getTime() - now.getTime();
      const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
      return days > 0 ? days : 1;
    }

    return 1;
  }

  republishJob(item: any) {
    this.util.startLoader();
    this.api.updatePut("jobs/updateJob", item).subscribe((res) => {
      this.util.stopLoader();
      if (res.code === GigsumoConstants.SUCESSCODE) {
        this.jobReload.emit("reload");
        Swal.fire({
          icon: "success",
          title: "Job Republished Successfully",
          showDenyButton: false,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  upgradeJobs(data : JobModel,type?:any){
    data.isFeatured = true;
    data.consumptionType = "JOBS_CANDIDATE_SPOTLIGHTS";
    if(type){
      data.consumptionType = type;
    }
     this.api.updatePut("jobs/updateJob", data).subscribe((res) => { 
        this.util.stopLoader();
        if (res.code === GigsumoConstants.SUCESSCODE) { 
          this.jobReload.emit("reload");
          Swal.fire({
            icon: "success",
            title: "Job Upgraded Successfully",
            showDenyButton: false,
            showConfirmButton: false,
            timer: 2000,
          }); 
        }
      },
      err => {
      this.util.stopLoader();
    });
  }



  test() {

  }

  fileChangeEvent(data) {
    this.myFileInputcandidate.nativeElement.click();
  }


  sortDate(data) {
    return data.sort((a, b) => {
      return b.isFeatured - a.isFeatured;
    });
  }

  sortDateByNormalJobs(passValues: any) {
    let sortedDate = passValues.sort((a, b) => { return <any>new Date(b.updatedOn) - <any>new Date(a.updatedOn); })
    this.sortDate(sortedDate);
  }




  jobIdHighLight: any

  confirmStatusChange(status:any, item:any) {
    // Close the controlled status pill dropdown (see enableJob) — its option
    // click's stopPropagation() otherwise leaves the menu open.
    this.openStatusPillId = null;
    Swal.fire({
      title: 'Change Job Status to Filled?',
      text: "Are you sure you want to change job status to filled.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.enableJob(status, item);
      }
    });
  }

  // Returns whether the status change actually proceeded. When activating and
  // the plan is exhausted, the exhaust popup is shown and the status is left
  // unchanged → returns false so the caller (new-job toggleSelectedJob) can
  // revert its toggle UI.
  async enableJob(event, value): Promise<boolean> {
    // Prevent double-clicks while processing
    if (this.isProcessingStatusChange) {
      console.log('enableJob: blocked - already processing');
      return false;
    }
    this.isProcessingStatusChange = true;
    console.log('enableJob: started', event, value?.jobId, 'currentStatus:', value?.status);

    // Defensive check: skip if trying to set status to current status
    if (event === value?.status) {
      console.warn('enableJob: SKIPPED - event matches current status (stale dropdown state detected)');
      this.isProcessingStatusChange = false;
      return false;
    }

    try {
      if (event === 'ACTIVE') {
        // CRITICAL FIX: Close ALL dropdowns BEFORE the async call
        // This ensures dropdown is closed before popup appears
        this.openStatusPillId = null;
        // Force-close any ngx-bootstrap dropdowns immediately
        document.body.click();
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }

        const isPlanValid = await this.planService.checkUserPlanValid("JOB_CANDIDATE_POSTINGS", "JOBS_CANDIDATES");
        console.log('enableJob: isPlanValid =', isPlanValid);
        if (isPlanValid === true) {
          this.afterPlanValidationstatuschange(event, value);
          return true;
        }
        // Plan exhausted → popup was shown, status left unchanged (dropdown already closed above).
        return false;
      } else {
        // Close the controlled left-card status pill dropdown for non-ACTIVE
        // changes too (On Hold) — its option click's stopPropagation() otherwise
        // leaves the menu open.
        this.openStatusPillId = null;
        this.afterPlanValidationstatuschange(event, value);
        return true;
      }
    } catch (error) {
      console.error('enableJob: error during plan validation', error);
      return false;
    } finally {
      // Reset flag after operation completes (success or failure)
      // Small delay to prevent rapid re-clicks during async transitions
      setTimeout(() => {
        this.isProcessingStatusChange = false;
        console.log('enableJob: processing flag reset');
      }, 500);
    }
  }


  afterPlanValidationstatuschange(event, value) {
    value.status = event;
    let datas: any = {};
    var datacheck = [{ 'userId': localStorage.getItem('userId') }]
    datas.jobPostedBy = localStorage.getItem('userId');
    datas.jobId = value.jobId;
    datas.appliedBy = datacheck;
    value.jobReferenceId=value.jobId;

    this.api.updatePut("jobs/updateJob", value).subscribe(jobres => {
      if (jobres) {
        this.util.stopLoader();
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Job updated successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        if(jobres && jobres.data && jobres.data.jobData) {
          let data: any = {};
          data.job = jobres.data.jobData;
          data.event = event;
          this.updateStatusAndFilters.emit(data);
        }
      }

      });

  }





  serverCurrentDate: string;
  servertimedate: string;
  autoComplete1: MatAutocompleteTrigger;
  searchBarShow1: boolean = false
  uniqueOrgList1: Array<Partial<HealthCareOrganization>> = [];
  payType: null;
  targetRate: null;
  figureLength: number = 0;
  selectedCountries: boolean = false
  typeTargetValue: null;
  countryChosen: null;


  commonVariables: any = {};

  noResult: boolean = false

  sortConfigWork: TypeaheadOrder = {
    direction: "desc",
    field: "organisationName",
  };



  config2 = {
    focus: false,
    height: 150,
    placeholder: "",
    link: [["link", ["linkDialogShow", "unlink"]]],
    insert: ["link", "picture", "video"],
    view: ["fullscreen", "codeview", "help"],
    style:
      "outline: none !important;background-color: rgb(241 243 246) !important;cursor: pointer !important;",
    disableDragAndDrop: true,
    blockquoteBreakingLevel: 1,
    callbacks: {
      onFocus: function (contents) {
        if ($(this).summernote("isEmpty")) {
          $("#summessage").html(""); //either the class (.) or id (#) of your textarea or summernote element
        }
      },
    },
    toolbar: [
      ["misc", ["codeview", "undo", "redo"]],
      // ['style', ['bold', 'italic', 'underline', 'clear']],
      [
        "font",
        [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "superscript",
          "subscript",
          "clear",
        ],
      ],
      ["fontsize", ["fontname", "fontsize", "color"]],
      ["para", ["style", "ul", "ol", "paragraph", "height"]],
    ],
    fontNames: [
      "Helvetica",
      "Arial",
      "Arial Black",
      "Comic Sans MS",
      "Courier New",
      "Roboto",
      "Times",
    ]
  };

  modalRef: BsModalRef;
  otherStatesList: any = [];
  editedJob: Partial<JobModel>
  //open the job modal by monisha
  @ViewChild(JobTemplateComponent, { static: false }) jobTemplateComponent: JobTemplateComponent; // Reference to the JobTemplateComponent
  async editJob(item) {
    if (this.jobTemplateComponent) {
          this.jobTemplateComponent.openJobModal(item); // Open the modal
         }
  }
  @Output() jobReloadFromJobComponent = new EventEmitter<any>();
  onJobReload(event: any) {
    // Re-emit the event to the parent (NewJobComponent) by monisha
    this.jobReloadFromJobComponent.emit(event);
  }

  formatDates(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;

    }

    return [year, month, day].join('/');
  }

  chatuser(seletedItem, connectionTemplate?: TemplateRef<any>) {

    if(seletedItem.jobPostedBy == this.userId){
      seletedItem.userId= this.userId;
      seletedItem.owner = true;
    }
         this.openMessage({...seletedItem});
  }
  //adjust the button padding size in extra-small popups by monisha
  getStatusLabelStyle(items: any): { [key: string]: string } {
    const baseStyle = this.getStyle(items?.currentStatus||items?.inviteStatus) || {};
    const padding = this.getFilterValue(items) ? '2px 5px' : '0';
    return { ...baseStyle, padding };
  }


  openMessage(seletedItem) {
    this.messagemodelflag = false;
    setTimeout(() => {
      seletedItem.userId = seletedItem.jobPostedBy;
      this.seletedChatItem = seletedItem;
      this.messageData = [];
      this.messagemodelflag = true;
      seletedItem.groupType = "JOB";
      seletedItem.messageType = "JOB";
      seletedItem.id = seletedItem.jobId;
      this.messageData = seletedItem;

    }, 1000);

  }
  async openMessagecheckInteraction(seletedItem, connectionTemplate?: TemplateRef<any>) {
    // Universal first-interaction: exist-first — skip the ACTIVE_INTERACTIONS gate
    // (findUserPlanBenefits / findPlans) when this job's interaction was already
    // consumed (existing chat OR prior apply — backend `alreadyConsumed`). A fresh
    // Marketplace Job still gates. Fails safe.
    if (await this.planService.isInteractionAlreadyConsumed(seletedItem?.jobId, 'JOB')) {
      this.chatuser(seletedItem);
      return;
    }
    try {
      this.util.startLoader();
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { userDetail, isExpired, membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      if (userDetail && userDetail.userPlanAndBenefits && userDetail.userPlanAndBenefits.benefitsUsages) {
        userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available;
            actualPoints = ele.actual;
            utilizedPoints = ele.utilized;
            promotional = ele.promotional;
          }
        });
      } else {
        this.util.startLoader();
        this.chatuser(seletedItem);

        return;
      }

      if (isExpired) {
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter','Growth','ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }

        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null,null, availablePoints, actualPoints, utilizedPoints, promotional);

      } else {
        this.util.startLoader();
        this.chatuser(seletedItem);

      }
    } catch (error) {
    } finally {
      setTimeout(() => {
        this.util.stopLoader();
      },1500);
    }

  }

  closeMessage(event) {
    this.messagemodelflag = false;

  }

  //delete draft function by monisha
  deletedraft(id: any) {

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: 'Do you wish to discard?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.util.startLoader();
        this.api.delete('jobs/delete/' + id).subscribe(res => {
          if (res.code == "00000") {
            this.util.stopLoader();
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Discarded Sucessfully',
              showConfirmButton: false,
              timer: 1500
            })
            this.jobReload.emit("discard");
          }
        })
      }
    })
      ;
  }

  getPhotoUrl(photo: string): string {
    if (!photo) {
      return '';
    }
    // If photo already starts with http/https, return as-is
    if (photo.startsWith('http://') || photo.startsWith('https://')) {
      return photo;
    }
    // Otherwise, prepend the base URL
    return this.downloadurl + photo;
  }
}




